import { UserRole } from './enums';

export type NotificationCategory = 'action_required' | 'informasi' | 'peringatan';
export type NotificationStatus = 'pending' | 'sent' | 'failed' | 'archived';
export type NotificationPriority = 'low' | 'medium' | 'high' | 'urgent';

export interface Notification {
  id: string;
  title: string;
  content: string;
  category: NotificationCategory;
  priority: NotificationPriority;
  status: NotificationStatus;
  targetRole?: UserRole | null;
  targetBranchId?: string | null;
  targetCustomUsers?: string[];
  enablePush: boolean;
  enableEmail: boolean;
  enableSms: boolean;
  scheduledAt?: string | null;
  expiresAt?: string | null;
  createdBy?: string | null;
  createdAt: string;
  updatedAt?: string;
  actionUrl?: string | null;
}

export interface NotificationRecipient {
  id: string;
  notificationId: string;
  userId: string;
  readAt?: string | null;
  deletedAt?: string | null;
  pushSentAt?: string | null;
  emailSentAt?: string | null;
  smsSentAt?: string | null;
  pushFailed?: string | null;
  emailFailed?: string | null;
  smsFailed?: string | null;
  createdAt: string;
}

export interface UserNotification {
  id: string;
  title: string;
  content: string;
  category: NotificationCategory;
  priority: NotificationPriority;
  status: 'read' | 'deleted' | 'unread';
  targetRole?: UserRole | null;
  actionUrl?: string | null;
  createdAt: string;
  expiresAt?: string | null;
  readAt?: string | null;
  deletedAt?: string | null;
}

export interface NotificationPreferences {
  pushEnabled: boolean;
  emailEnabled: boolean;
  smsEnabled: boolean;
  transactionAlerts: boolean;
  balanceAlerts: boolean;
  securityAlerts: boolean;
}

export const NotificationCategoryConfig: Record<NotificationCategory, {
  color: string;
  icon: string;
  label: string;
  bgColor: string;
}> = {
  action_required: {
    color: '#dc2626',
    icon: '🔴',
    label: 'Action Required',
    bgColor: '#fee2e2',
  },
  informasi: {
    color: '#2563eb',
    icon: '🔵',
    label: 'Informasi',
    bgColor: '#dbeafe',
  },
  peringatan: {
    color: '#ea580c',
    icon: '🟡',
    label: 'Peringatan',
    bgColor: '#fed7aa',
  },
};

export const NotificationPriorityConfig: Record<NotificationPriority, {
  color: string;
  label: string;
}> = {
  low: { color: '#9ca3af', label: 'Rendah' },
  medium: { color: '#2563eb', label: 'Sedang' },
  high: { color: '#ea580c', label: 'Tinggi' },
  urgent: { color: '#dc2626', label: 'Mendesak' },
};
